<template>
	<div>
		<div v-if="blackout" class="slideout-blackout" />
		<transition :name="transition ? 'slideout-container' : 'disable'" appear>
			<div class="sideout-container" :size="size">
				<transition :name="transition ? 'slideout' : 'disable'" mode="out-in">
					<!-- @slot Used to display 'Slideout' Components -->
					<slot />
				</transition>
			</div>
		</transition>
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * SlideoutContainer is used display on right hand side of the app. It will have transition,blackout and different sizes.
 */
export default defineComponent({
	name: "SlideoutContainer",
	props: {
		/**
		 * 'small' | 'medium' | 'large'
		 */
		size: {
			type: String,
			default: "small",
			validator(value) {
				return ["small", "medium", "large"].includes(value);
			}
		},
		/**
		 * true | false
		 * <br/> Used to enable/disable transition
		 *
		 */
		transition: {
			type: Boolean,
			default: true
		},
		/**
		 * true | false
		 * <br/> Used to enable/disable blackout
		 *
		 */
		blackout: {
			type: Boolean,
			default: true
		}
	}
});
</script>
<style lang="scss">
$left-margin: 52px;
.slideout-container-enter {
	transform: translateX(100%);
}
.slideout-container-enter-to {
	transform: translateX(0);
}
.slideout-container-enter-active {
	animation: slideContainerIn 0.2s linear;
}

.slideout-container-leave-active {
	animation: slideContainerOut 0.2s linear;
}
.slideout-blackout {
	content: "";
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: var(--slideout-blackout);
	// transition: background 0.3s linear;
	z-index: 92;
	animation: blackout 0.4s linear;
}
.sideout-container {
	position: fixed;
	top: 0px;
	right: 0px;
	bottom: 0px;

	background-color: var(--slideout-background);
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;

	transition: width 0.5s linear;

	z-index: 100;

	div > & {
		min-height: 600px;
	}
	/* Small devices (landscape phones, 576px and up) */
	@media (max-width: 575px) {
		&[size="small"] {
			width: calc(100% - 8px);
		}
		&[size="medium"] {
			width: calc(100% - 8px);
		}
		&[size="large"] {
			width: calc(100% - 8px);
		}
	}

	@media (min-width: 576px) {
		&[size="small"] {
			width: 400px;
		}
		&[size="medium"] {
			width: calc((100% - #{$left-margin}) * 1);
		}
		&[size="large"] {
			width: calc((100% - #{$left-margin}) * 1);
		}
	}

	/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
	@media (min-width: 768px) {
		&[size="small"] {
			width: 400px;
		}
		&[size="medium"] {
			width: calc((100% - #{$left-margin}) * 1);
		}
		&[size="large"] {
			width: calc((100% - #{$left-margin}) * 1);
		}
	}

	/* Large devices (desktops, 992px and up) */
	@media (min-width: 992px) {
		&[size="small"] {
			width: 400px;
		}
		&[size="medium"] {
			width: 70%;
		}
		&[size="large"] {
			width: calc((100% - #{$left-margin}) * 1);
		}
	}

	/* Extra large devices (large desktops, 1200px and up) */
	@media (min-width: 1200px) {
		&[size="small"] {
			width: calc((100% - #{$left-margin}) / 3);
			max-width: 400px;
		}
		&[size="medium"] {
			width: calc((100% - #{$left-margin}) * (2 / 3));
			max-width: 800px;
		}
		&[size="large"] {
			width: calc((100% - #{$left-margin}) * 1);
		}
	}
}

@keyframes slideContainerIn {
	0% {
		transform: translateX(100%);
	}
	100% {
		transform: translateX(0);
	}
}

@keyframes slideContainerOut {
	0% {
		transform: translateX(0);
	}
	100% {
		transform: translateX(100%);
	}
}
@keyframes blackout {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
